import styled from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
} from '@telialt/common-theme/src/purpurSelectors';

export const StyledButton = styled.button`
    display: inline-flex;
    padding: ${getPurpurSpacing('200')};
    gap: ${getPurpurSpacing('200')};
    align-items: center;
    border-radius: ${getPurpurBorder('radiusMd')};
    border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderInteractiveSubtle')};

    ${purpurFocus(getPurpurSpacing('50'))};
    &:hover,
    &:focus-visible {
        border-color: ${getPurpurColor('borderInteractivePrimaryHover')};
        box-shadow: 0 0 0 ${getPurpurBorder('widthXs')} ${getPurpurColor('borderInteractivePrimaryHover')};
    }
    &:active {
        border-color: ${getPurpurColor('borderInteractivePrimaryActive')};
        box-shadow: 0 0 0 ${getPurpurBorder('widthXs')} ${getPurpurColor('borderInteractivePrimaryActive')};
    }
`;

export const RectButtonText = styled.span`
    flex-grow: 1;
    text-align: start;
    color: ${getPurpurColor('textDefault')};

    font-size: ${getPurpurTypography('scale100')};
    font-weight: ${getPurpurTypography('weightBold')};
    line-height: ${getPurpurTypography('lineHeightLooser')};
`;
